import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  ABOUT_COFFEE_CHAT_UUID,
  ABOUT_COFFEE_RESTAURANT_UUID,
  AGRI_CO_SUPPLIER_UUID,
  ASIAN_FUSION_CHAT_UUID,
  ASIAN_FUSION_RESTAURANT_UUID,
  ASIAN_MARKET_CHAT_UUID,
  ASIAN_MARKET_RESTAURANT_UUID,
  BLUE_FIN_MARKET_CHAT_UUID,
  BLUE_FIN_MARKET_RESTAURANT_UUID,
  BOBS_BURGER_SHACK_CHAT_UUID,
  BOBS_BURGER_SHACK_RESTAURANT_UUID,
  BRONCO_DEMO_RESTAURANT_TO_CHAT,
  BRONCO_SUPPLIER_UUID,
  CENTRAL_CONFERENCE_CENTRE_CHAT_UUID,
  CENTRAL_CONFERENCE_CENTRE_RESTAURANT_UUID,
  CHIPOTLE_MEXICAN_GRILL_CHAT_UUID,
  CHOWDER_HOUSE_CHAT_UUID,
  CHOWDER_HOUSE_RESTAURANT_UUID,
  COASTAL_KITCHEN_SEAFOOD_CHAT_UUID,
  COASTAL_KITCHEN_SEAFOOD_RESTAURANT_UUID,
  COWS_CREAMERY_CHAT_UUID,
  COWS_CREAMERY_RESTAURANT_UUID,
  DOWNTOWN_HIGH_SCHOOL_CHAT_UUID,
  DOWNTOWN_HIGH_SCHOOL_RESTAURANT_UUID,
  DUTCH_DREAMS_CHAT_UUID,
  DUTCH_DREAMS_RESTAURANT_UUID,
  FIELDSTONE_KITCHEN_CHAT_UUID,
  FIELDSTONE_KITCHEN_RESTAURANT_UUID,
  FINE_AND_CURED_CHAT_UUID,
  FINE_AND_CURED_RESTAURANT_UUID,
  FLAVOR_HEAVEN_CHAT_UUID,
  FLAVOR_HEAVEN_RESTAURANT_UUID,
  GARDEN_CAFE_CHAT_UUID,
  GARDEN_CAFE_RESTAURANT_UUID,
  GENERAL_NUTRITION_CHAT_UUID,
  GENERAL_NUTRITION_RESTAURANT_UUID,
  GOURMET_ICE_CREAM_CHAT_UUID,
  GOURMET_ICE_CREAM_RESTAURANT_UUID,
  GRILL_110_CHAT_UUID,
  GRILL_110_RESTAURANT_UUID,
  HOLLAND_PARK_CHAT_UUID,
  HOLLAND_PARK_RESTAURANT_UUID,
  HUTCHS_ON_THE_BEACH_CHAT_UUID,
  HUTCHS_ON_THE_BEACH_RESTAURANT_UUID,
  JEFFS_GOURMET_KITCHEN_CHAT_UUID,
  JEFFS_GOURMET_KITCHEN_RESTAURANT_UUID,
  JOHNS_BAR_AND_GRILL_CHAT_UUID,
  JOHNS_BAR_AND_GRILL_RESTAURANT_UUID,
  JOHNS_SEAFOOD_HOUSE_CHAT_UUID,
  JOHNS_SEAFOOD_HOUSE_RESTAURANT_UUID,
  KENS_CATERING_CHAT_UUID,
  KENS_CATERING_RESTAURANT_UUID,
  LAKESHORE_DELI_CHAT_UUID,
  LAKESHORE_DELI_RESTAURANT_UUID,
  MALLORYS_SEAFOOD_CHAT_UUID,
  MALLORYS_STEAKHOUSE_CHAT_UUID,
  MALLORYS_STEAKHOUSE_RESTAURANT_UUID,
  MAPLEWOOD_MART_CHAT_UUID,
  MAPLEWOOD_MART_RESTAURANT_UUID,
  MARILUS_MARKET_CHAT_UUID,
  NOUVEAU_BISTRO_CHAT_UUID,
  NOUVEAU_BISTRO_RESTAURANT_UUID,
  RAYS_CSTORE_CHAT_UUID,
  RAYS_CSTORE_RESTAURANT_UUID,
  RAZAS_RESTAURANT_CHAT_UUID,
  RAZAS_RESTAURANT_RESTAURANT_UUID,
  RIDGELINE_CSTORE_CHAT_UUID,
  RIDGELINE_CSTORE_RESTAURANT_UUID,
  ROESES_RIB_ROOM_CHAT_UUID,
  RYANS_RIPPIN_RESTAURANT_CHAT_UUID,
  RYANS_RIPPIN_RESTAURANT_RESTAURANT_UUID,
  SFF_SUPPLIER_UUID,
  SIAM_DISH_CHAT_UUID,
  SIAM_DISH_RESTAURANT_UUID,
  SPECIALTY_GOODS_CHAT_UUID,
  SPECIALTY_GOODS_RESTAURANT_UUID,
  ST_MORITZ_HOTEL_CHAT_UUID,
  ST_MORITZ_HOTEL_RESTAURANT_UUID,
  SUMMIT_STEAKHOUSE_CHAT_UUID,
  SUMMIT_STEAKHOUSE_RESTAURANT_UUID,
  THE_CARRIAGE_HOUSE_CHAT_UUID,
  THE_CARRIAGE_HOUSE_RESTAURANT_UUID,
  THE_CARVING_BLOCK_CHAT_UUID,
  THE_CARVING_BLOCK_RESTAURANT_UUID,
  THE_DAILY_PLATE_CHAT_UUID,
  THE_DAILY_PLATE_RESTAURANT_UUID,
  THE_DUCK_INN_CHAT_UUID,
  THE_DUCK_INN_RESTAURANT_UUID,
  THE_PROVISIONS_COUNTER_CHAT_UUID,
  THE_PROVISIONS_COUNTER_RESTAURANT_UUID,
  THE_REAL_SCOOP_CHAT_UUID,
  THE_REAL_SCOOP_RESTAURANT_UUID,
  THE_SURF_CLUB_RESTAURANT_CHAT_UUID,
  THE_SURF_CLUB_RESTAURANT_RESTAURANT_UUID,
  TINA_TUNA_CHAT_UUID,
  TINA_TUNA_RESTAURANT_UUID,
  VALLEY_EXPRESS_CHAT_UUID,
  VALLEY_EXPRESS_RESTAURANT_UUID,
  WESS_BISTRO_CHAT_UUID,
} from '@/mocks/uuids';
import { AnalyticsAlertResponse } from '@/components/dsr-analytics/types';
import { AnalyticsAlertStatusType, AnalyticsAlertType } from '@/types';
import { v4 as uuidv4 } from 'uuid';

/*
  Mock data for analytics dashboard.
  Essential for toggling visibility of React components based on specific conditions
*/
export const mockAlertsData: Record<string, AnalyticsAlertResponse[]> = {
  [ABOUT_COFFEE_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: ABOUT_COFFEE_CHAT_UUID,
      restaurant_uuid: ABOUT_COFFEE_RESTAURANT_UUID,
      subtitle: {
        en: "About Coffee hasn't placed an order in 13 days (9/5). The previous largest gap in ordering was 6 days.",
        es: 'About Coffee no ha realizado un pedido en 13 días (9/5). El mayor intervalo sin pedidos anterior fue de 6 días.',
        fr: "About Coffee n'a pas passé commande depuis 13 jours (9/5). Le plus grand intervalle sans commande précédent était de 6 jours.",
        zh: 'About Coffee 已經有 13 天沒有下單 (9/5)。前一個最大間隔沒有訂單的時間是 6 天。',
      },
      supplier_uuid: AGRI_CO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.OverduePayment,
      chat_uuid: ABOUT_COFFEE_CHAT_UUID,
      data: [
        {
          alert_uuid: uuidv4(),
          amount: 1696650000,
          due_at: '2023-11-08 06:00:00.000 Z',
          invoice_number: 'VQOVS3YZS',
          order_invoice_uuid: uuidv4(),
        },
        {
          alert_uuid: uuidv4(),
          amount: 2652190000,
          due_at: '2023-11-06 06:00:00.000 Z',
          invoice_number: 'GGCZPYOHX',
          order_invoice_uuid: uuidv4(),
        },
        {
          alert_uuid: uuidv4(),
          amount: 1536650000,
          due_at: '2023-11-04 06:00:00.000 Z',
          invoice_number: 'GD7OFGEA4',
          order_invoice_uuid: uuidv4(),
        },
        {
          alert_uuid: uuidv4(),
          amount: 2013350000,
          due_at: '2023-10-28 06:00:00.000 Z',
          invoice_number: 'CX2FBJ972',
          order_invoice_uuid: uuidv4(),
        },
      ],
      restaurant_uuid: ABOUT_COFFEE_RESTAURANT_UUID,
      subtitle: {
        en: 'About Coffee has 4 overdue invoices.',
        es: 'About Coffee tiene 4 facturas vencidas.',
        fr: 'About Coffee a 4 factures en retard.',
        zh: 'About Coffee 有 4 張逾期未付的發票。',
      },
      supplier_uuid: AGRI_CO_SUPPLIER_UUID,
      title: {
        en: 'Overdue Payment',
        es: 'Factura vencida',
        fr: 'Facture en retard',
        zh: '逾期未付發票',
      },
    },
  ],

  // ===========================================================================
  // Bronco Demo Accounts (DSR-3748)
  // Alerts data per the "Sales Hub Bronco Demo Hardcode March'26" spreadsheet.
  // Lost Item VP UUIDs come from the CSV "(MOST ACCURATE) VP UUID" column.
  // ===========================================================================

  // --- Asian ---
  [ASIAN_FUSION_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: ASIAN_FUSION_CHAT_UUID,
      display_name: 'Chinese Shiitake Mushroom | 大号新鲜冬菇',
      external_item_id: '',
      pack_unit: 'Case',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/fa15ba6c-f547-51c3-a5c5-0774908fe0cf.jpg',
      ],
      restaurant_uuid: ASIAN_FUSION_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Asian Fusion',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Asian Fusion',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Asian Fusion",
        zh: '根據最新訂單歷史，此商品對 Asian Fusion 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: 'd3debb1c-3e44-428c-85fb-62f9a85b2b63',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: ASIAN_FUSION_CHAT_UUID,
      restaurant_uuid: ASIAN_FUSION_RESTAURANT_UUID,
      subtitle: {
        en: "Asian Fusion hasn't placed an order in 11 days. The previous largest gap in ordering was 5 days.",
        es: 'Asian Fusion no ha realizado un pedido en 11 días. El mayor intervalo sin pedidos anterior fue de 5 días.',
        fr: "Asian Fusion n'a pas passé commande depuis 11 jours. Le plus grand intervalle sans commande précédent était de 5 jours.",
        zh: 'Asian Fusion 已經有 11 天沒有下單。前一個最大間隔沒有訂單的時間是 5 天。',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],
  [ASIAN_MARKET_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: ASIAN_MARKET_CHAT_UUID,
      display_name: 'Golden Burdock Root (Gobo) | 牛蒡',
      external_item_id: '',
      pack_unit: 'Case',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/121f02df-ed91-58a6-8eb7-7ecd0753c5f8.jpg',
      ],
      restaurant_uuid: ASIAN_MARKET_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Asian Market',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Asian Market',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Asian Market",
        zh: '根據最新訂單歷史，此商品對 Asian Market 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '6c3b7a9c-1653-48c4-a073-9438bb096b8a',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: ASIAN_MARKET_CHAT_UUID,
      restaurant_uuid: ASIAN_MARKET_RESTAURANT_UUID,
      subtitle: {
        en: "Asian Market hasn't placed an order in 10 days. The previous largest gap in ordering was 5 days.",
        es: 'Asian Market no ha realizado un pedido en 10 días. El mayor intervalo sin pedidos anterior fue de 5 días.',
        fr: "Asian Market n'a pas passé commande depuis 10 jours. Le plus grand intervalle sans commande précédent était de 5 jours.",
        zh: 'Asian Market 已經有 10 天沒有下單。前一個最大間隔沒有訂單的時間是 5 天。',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],

  // --- Seafood ---
  [BLUE_FIN_MARKET_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: BLUE_FIN_MARKET_CHAT_UUID,
      display_name: 'Chesapeake Bay Blue Catfish',
      external_item_id: '',
      pack_unit: 'Pound',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/f7552385-2c88-52ce-a5fb-42a8d80f089f.webp',
      ],
      restaurant_uuid: BLUE_FIN_MARKET_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Blue Fin Market',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Blue Fin Market',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Blue Fin Market",
        zh: '根據最新訂單歷史，此商品對 Blue Fin Market 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: 'de9dfe4f-b01f-4ea4-a1a1-62ebf66d46a0',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: BLUE_FIN_MARKET_CHAT_UUID,
      restaurant_uuid: BLUE_FIN_MARKET_RESTAURANT_UUID,
      subtitle: {
        en: "Blue Fin Market hasn't placed an order in 10 days. The previous largest gap in ordering was 5 days.",
        es: 'Blue Fin Market no ha realizado un pedido en 10 días. El mayor intervalo sin pedidos anterior fue de 5 días.',
        fr: "Blue Fin Market n'a pas passé commande depuis 10 jours. Le plus grand intervalle sans commande précédent était de 5 jours.",
        zh: 'Blue Fin Market 已經有 10 天沒有下單。前一個最大間隔沒有訂單的時間是 5 天。',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],
  [BOBS_BURGER_SHACK_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: BOBS_BURGER_SHACK_CHAT_UUID,
      display_name: 'Russet Potato 50ct',
      external_item_id: '750POT',
      pack_unit: 'CASE',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/f4d8ba32-df5a-4bad-bf94-cf0a1c89e109/items/d4bba7c2-541e-4030-b42f-05931bc39f90.jpeg',
      ],
      restaurant_uuid: BOBS_BURGER_SHACK_RESTAURANT_UUID,
      subtitle: {
        en: "Based on latest order history, this item is at risk for Bob's Burger Shack",
        es: "Based on latest order history, this item is at risk for Bob's Burger Shack",
        fr: "Based on latest order history, this item is at risk for Bob's Burger Shack",
        zh: "Based on latest order history, this item is at risk for Bob's Burger Shack",
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '6ed7c4e9-ba3d-4ee4-91ca-8533a0ccc099',
    },
  ],

  // --- JanSan ---
  [CENTRAL_CONFERENCE_CENTRE_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: CENTRAL_CONFERENCE_CENTRE_CHAT_UUID,
      display_name: 'Betco® Fastdraw 32 Green Earth Restroom Cleaner',
      external_item_id: '',
      pack_unit: 'Each',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/c31fb6e2-80c7-5f48-be45-6577bd6fa399.jpg',
      ],
      restaurant_uuid: CENTRAL_CONFERENCE_CENTRE_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Central Conference Centre',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Central Conference Centre',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Central Conference Centre",
        zh: '根據最新訂單歷史，此商品對 Central Conference Centre 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: 'e010d3e2-e22d-4455-9913-dc447723ff83',
    },
  ],
  [CHIPOTLE_MEXICAN_GRILL_CHAT_UUID]: [],
  [CHOWDER_HOUSE_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: CHOWDER_HOUSE_CHAT_UUID,
      display_name: 'Smoked Sturgeon 6oz/12',
      external_item_id: '',
      pack_unit: 'PACK',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/2a70d37c-82ce-5f58-b1a2-ac8f3ae4ee42.png',
      ],
      restaurant_uuid: CHOWDER_HOUSE_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Chowder House',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Chowder House',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Chowder House",
        zh: '根據最新訂單歷史，此商品對 Chowder House 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '13ea7da4-c9a7-4674-b6e1-07fa2d8402d6',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: CHOWDER_HOUSE_CHAT_UUID,
      restaurant_uuid: CHOWDER_HOUSE_RESTAURANT_UUID,
      subtitle: {
        en: "Chowder House hasn't placed an order in 8 days. The previous largest gap in ordering was 4 days.",
        es: 'Chowder House no ha realizado un pedido en 8 días. El mayor intervalo sin pedidos anterior fue de 4 días.',
        fr: "Chowder House n'a pas passé commande depuis 8 jours. Le plus grand intervalle sans commande précédent était de 4 jours.",
        zh: 'Chowder House 已經有 8 天沒有下單。前一個最大間隔沒有訂單的時間是 4 天。',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],
  [COASTAL_KITCHEN_SEAFOOD_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: COASTAL_KITCHEN_SEAFOOD_CHAT_UUID,
      display_name: 'Salmon Roe',
      external_item_id: '',
      pack_unit: 'CASE',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/493ab9ab-dfb6-5ae6-b4e8-ff4bf4f6c56c.jpg',
      ],
      restaurant_uuid: COASTAL_KITCHEN_SEAFOOD_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Coastal Kitchen Seafood',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Coastal Kitchen Seafood',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Coastal Kitchen Seafood",
        zh: '根據最新訂單歷史，此商品對 Coastal Kitchen Seafood 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: 'ec18e7dd-8348-4b0d-ab23-942277b11528',
    },
  ],

  // --- Ice Cream ---
  [COWS_CREAMERY_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: COWS_CREAMERY_CHAT_UUID,
      display_name: 'Blue Ribbon Classics Cool Tubes Rainbow, 2dz',
      external_item_id: '',
      pack_unit: 'Each',
      photo_url_list: [],
      restaurant_uuid: COWS_CREAMERY_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Cows Creamery',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Cows Creamery',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Cows Creamery",
        zh: '根據最新訂單歷史，此商品對 Cows Creamery 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '06ff2a71-9975-43c2-8ce7-49703b74cd67',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: COWS_CREAMERY_CHAT_UUID,
      restaurant_uuid: COWS_CREAMERY_RESTAURANT_UUID,
      subtitle: {
        en: "Cows Creamery hasn't placed an order in 11 days. The previous largest gap in ordering was 6 days.",
        es: 'Cows Creamery no ha realizado un pedido en 11 días. El mayor intervalo sin pedidos anterior fue de 6 días.',
        fr: "Cows Creamery n'a pas passé commande depuis 11 jours. Le plus grand intervalle sans commande précédent était de 6 jours.",
        zh: 'Cows Creamery 已經有 11 天沒有下單。前一個最大間隔沒有訂單的時間是 6 天。',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],
  [DOWNTOWN_HIGH_SCHOOL_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: DOWNTOWN_HIGH_SCHOOL_CHAT_UUID,
      display_name: '1/2 lb #50 Food Tray Red Check',
      external_item_id: '',
      pack_unit: 'Case',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/bb3efe8b-98b0-59b5-b203-167c375c5ac8.jpg',
      ],
      restaurant_uuid: DOWNTOWN_HIGH_SCHOOL_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Downtown High School',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Downtown High School',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Downtown High School",
        zh: '根據最新訂單歷史，此商品對 Downtown High School 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: 'eec4671d-4f00-4d1e-a6cb-30bde308519e',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: DOWNTOWN_HIGH_SCHOOL_CHAT_UUID,
      restaurant_uuid: DOWNTOWN_HIGH_SCHOOL_RESTAURANT_UUID,
      subtitle: {
        en: "Downtown High School hasn't placed an order in 8 days. The previous largest gap in ordering was 4 days.",
        es: 'Downtown High School no ha realizado un pedido en 8 días. El mayor intervalo sin pedidos anterior fue de 4 días.',
        fr: "Downtown High School n'a pas passé commande depuis 8 jours. Le plus grand intervalle sans commande précédent était de 4 jours.",
        zh: 'Downtown High School 已經有 8 天沒有下單。前一個最大間隔沒有訂單的時間是 4 天。',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],
  [DUTCH_DREAMS_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: DUTCH_DREAMS_CHAT_UUID,
      restaurant_uuid: DUTCH_DREAMS_RESTAURANT_UUID,
      subtitle: {
        en: "Dutch Dreams Ice Cream hasn't placed an order in 10 days. The previous largest gap in ordering was 5 days.",
        es: 'Dutch Dreams Ice Cream no ha realizado un pedido en 10 días. El mayor intervalo sin pedidos anterior fue de 5 días.',
        fr: "Dutch Dreams Ice Cream n'a pas passé commande depuis 10 jours. Le plus grand intervalle sans commande précédent était de 5 jours.",
        zh: 'Dutch Dreams Ice Cream 已經有 10 天沒有下單。前一個最大間隔沒有訂單的時間是 5 天。',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],

  // --- Produce ---
  [FIELDSTONE_KITCHEN_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: FIELDSTONE_KITCHEN_CHAT_UUID,
      display_name: 'Organic Heirloom Tomatoes',
      external_item_id: '',
      pack_unit: 'Bag',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/edef36af-ce82-5f2b-b984-4ce6257d4a25.png',
      ],
      restaurant_uuid: FIELDSTONE_KITCHEN_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Fieldstone Kitchen',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Fieldstone Kitchen',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Fieldstone Kitchen",
        zh: '根據最新訂單歷史，此商品對 Fieldstone Kitchen 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '07bfc2e5-d1c5-47f8-8d9b-cc77bf43ba59',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: FIELDSTONE_KITCHEN_CHAT_UUID,
      restaurant_uuid: FIELDSTONE_KITCHEN_RESTAURANT_UUID,
      subtitle: {
        en: "Fieldstone Kitchen hasn't placed an order in 11 days. The previous largest gap in ordering was 5 days.",
        es: 'Fieldstone Kitchen no ha realizado un pedido en 11 días. El mayor intervalo sin pedidos anterior fue de 5 días.',
        fr: "Fieldstone Kitchen n'a pas passé commande depuis 11 jours. Le plus grand intervalle sans commande précédent était de 5 jours.",
        zh: 'Fieldstone Kitchen 已經有 11 天沒有下單。前一個最大間隔沒有訂單的時間是 5 天。',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],

  // --- LP ---
  [FINE_AND_CURED_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: FINE_AND_CURED_CHAT_UUID,
      display_name: 'Hard Salami',
      external_item_id: '',
      pack_unit: 'Each',
      photo_url_list: [],
      restaurant_uuid: FINE_AND_CURED_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Fine & Cured',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Fine & Cured',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Fine & Cured",
        zh: '根據最新訂單歷史，此商品對 Fine & Cured 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '50548833-fa9a-4f9a-a8e1-6147872a39f1',
    },
  ],
  [FLAVOR_HEAVEN_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: FLAVOR_HEAVEN_CHAT_UUID,
      display_name: 'Steak',
      external_item_id: 'STE-01',
      pack_unit: 'BASKET',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/f4d8ba32-df5a-4bad-bf94-cf0a1c89e109/items/ece715e7-84c0-5759-954e-e78f6c0dce69.jpg',
      ],
      restaurant_uuid: FLAVOR_HEAVEN_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Flavor Heaven',
        es: 'Based on latest order history, this item is at risk for Flavor Heaven',
        fr: 'Based on latest order history, this item is at risk for Flavor Heaven',
        zh: 'Based on latest order history, this item is at risk for Flavor Heaven',
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '6ee4ba0c-c34b-4d94-85b8-09f98a2b2fc0',
    },
  ],
  [GARDEN_CAFE_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: GARDEN_CAFE_CHAT_UUID,
      display_name: 'Apple, Ginger Gold',
      external_item_id: '',
      pack_unit: 'Case',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/b4988872-c118-537d-a426-0ff8ec44c92c.jpg',
      ],
      restaurant_uuid: GARDEN_CAFE_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Garden Café',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Garden Café',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Garden Café",
        zh: '根據最新訂單歷史，此商品對 Garden Café 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '10c63081-0cc0-47ec-b379-2672d82c5890',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: GARDEN_CAFE_CHAT_UUID,
      restaurant_uuid: GARDEN_CAFE_RESTAURANT_UUID,
      subtitle: {
        en: "Garden Café hasn't placed an order in 9 days. The previous largest gap in ordering was 4 days.",
        es: 'Garden Café no ha realizado un pedido en 9 días. El mayor intervalo sin pedidos anterior fue de 4 días.',
        fr: "Garden Café n'a pas passé commande depuis 9 jours. Le plus grand intervalle sans commande précédent était de 4 jours.",
        zh: 'Garden Café 已經有 9 天沒有下單。前一個最大間隔沒有訂單的時間是 4 天。',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],
  [GENERAL_NUTRITION_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: GENERAL_NUTRITION_CHAT_UUID,
      restaurant_uuid: GENERAL_NUTRITION_RESTAURANT_UUID,
      subtitle: {
        en: "General Nutrition hasn't placed an order in 7 days (7/22). The previous largest gap in ordering was 5 days.",
        es: 'General Nutrition no ha realizado un pedido en 7 días (7/22). El mayor intervalo sin pedidos anterior fue de 5 días.',
        fr: "General Nutrition n'a pas passé commande depuis 7 jours (7/22). Le plus grand intervalle sans commande précédent était de 5 jours.",
        zh: 'General Nutrition 已經有 7 天沒有下單 (7/22)。前一個最大間隔沒有訂單的時間是 5 天。',
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],
  [GOURMET_ICE_CREAM_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: GOURMET_ICE_CREAM_CHAT_UUID,
      display_name: 'Jhs Dessert Topping Caramel 6/#10',
      external_item_id: 'TOP2',
      pack_unit: 'EACH',
      photo_url_list: [
        'https://pepper-salt-production.s3.us-east-1.amazonaws.com/ds_gtin_metadata/images/0192b4cd-9c96-7368-98ec-534d4b0e2180/3f88e619-4801-4e14-8063-f463af3149ed.jpg',
      ],
      restaurant_uuid: GOURMET_ICE_CREAM_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Gourmet Ice Cream',
        es: 'Based on latest order history, this item is at risk for Gourmet Ice Cream',
        fr: 'Based on latest order history, this item is at risk for Gourmet Ice Cream',
        zh: 'Based on latest order history, this item is at risk for Gourmet Ice Cream',
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '430e09fb-6074-43ff-80af-04dc22eb6412',
    },
  ],
  [GRILL_110_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: GRILL_110_CHAT_UUID,
      display_name: 'Vine Ripe Tomato, Red',
      external_item_id: '688678',
      pack_unit: 'CASE',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/f4d8ba32-df5a-4bad-bf94-cf0a1c89e109/items/fb1067f3-14fb-58e2-b645-875ab45d565a.jpg',
      ],
      restaurant_uuid: GRILL_110_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for 110 Grill',
        es: 'Based on latest order history, this item is at risk for 110 Grill',
        fr: 'Based on latest order history, this item is at risk for 110 Grill',
        zh: 'Based on latest order history, this item is at risk for 110 Grill',
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '091752fb-9672-4afe-935e-d003ab8aee09',
    },
  ],
  [HOLLAND_PARK_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: HOLLAND_PARK_CHAT_UUID,
      display_name: 'Chives 1# | Fresh',
      external_item_id: '',
      pack_unit: 'Pound',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/fee8c35b-8519-58df-8836-1d81607e8d5d.png',
      ],
      restaurant_uuid: HOLLAND_PARK_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Holland Park',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Holland Park',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Holland Park",
        zh: '根據最新訂單歷史，此商品對 Holland Park 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '9d58bc9d-8c32-47b2-98c1-797242895117',
    },
  ],
  [HUTCHS_ON_THE_BEACH_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: HUTCHS_ON_THE_BEACH_CHAT_UUID,
      display_name: 'Chocolate Soft Serve Mix 10%',
      external_item_id: '',
      pack_unit: 'Each',
      photo_url_list: [],
      restaurant_uuid: HUTCHS_ON_THE_BEACH_RESTAURANT_UUID,
      subtitle: {
        en: "Based on latest order history, this item is at risk for Hutch's on the Beach",
        es: "Según el historial de pedidos más reciente, este artículo está en riesgo para Hutch's on the Beach",
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Hutch's on the Beach",
        zh: "根據最新訂單歷史，此商品對 Hutch's on the Beach 存在風險",
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: 'f218c5af-6e48-40eb-9c52-66164adb00d3',
    },
  ],

  // --- Broadline ---
  [JEFFS_GOURMET_KITCHEN_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: JEFFS_GOURMET_KITCHEN_CHAT_UUID,
      display_name: "Bob's Red Mill Brown Rice Flour",
      external_item_id: '',
      pack_unit: 'Case',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/a58e23c2-456f-5eb1-bfd8-f2726df81c4b.jpg',
      ],
      restaurant_uuid: JEFFS_GOURMET_KITCHEN_RESTAURANT_UUID,
      subtitle: {
        en: "Based on latest order history, this item is at risk for Jeff's Gourmet Kitchen",
        es: "Según el historial de pedidos más reciente, este artículo está en riesgo para Jeff's Gourmet Kitchen",
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Jeff's Gourmet Kitchen",
        zh: "根據最新訂單歷史，此商品對 Jeff's Gourmet Kitchen 存在風險",
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '90f3fbb7-5770-40ff-92dd-6c210f74b999',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: JEFFS_GOURMET_KITCHEN_CHAT_UUID,
      restaurant_uuid: JEFFS_GOURMET_KITCHEN_RESTAURANT_UUID,
      subtitle: {
        en: "Jeff's Gourmet Kitchen hasn't placed an order in 10 days. The previous largest gap in ordering was 5 days.",
        es: "Jeff's Gourmet Kitchen no ha realizado un pedido en 10 días. El mayor intervalo sin pedidos anterior fue de 5 días.",
        fr: "Jeff's Gourmet Kitchen n'a pas passé commande depuis 10 jours. Le plus grand intervalle sans commande précédent était de 5 jours.",
        zh: "Jeff's Gourmet Kitchen 已經有 10 天沒有下單。前一個最大間隔沒有訂單的時間是 5 天。",
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],
  [JOHNS_BAR_AND_GRILL_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: JOHNS_BAR_AND_GRILL_CHAT_UUID,
      restaurant_uuid: JOHNS_BAR_AND_GRILL_RESTAURANT_UUID,
      subtitle: {
        en: "John's Bar & Grill hasn't placed an order in 13 days (9/5). The previous largest gap in ordering was 6 days.",
        es: "John's Bar & Grill hasn't placed an order in 13 days (9/5). The previous largest gap in ordering was 6 days.",
        fr: "John's Bar & Grill n'a pas passé commande depuis 13 jours (9/5). Le plus grand intervalle sans commande précédent était de 6 jours.",
        zh: "John's Bar & Grill 已經有 13 天沒有下單 (9/5)。前一個最大間隔沒有訂單的時間是 6 天。",
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],
  [JOHNS_SEAFOOD_HOUSE_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: JOHNS_SEAFOOD_HOUSE_CHAT_UUID,
      display_name: '❄️ Lobster Tail Meat 10#',
      external_item_id: 'Lob678FZ',
      pack_unit: 'POUND',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/ad_managers/49bd23c5-2f45-41e1-9c62-050dbfdd5af5/gtin_metadata/0a815ba9-5a68-4ff2-abc6-a16f5ee41cb1.jpg',
      ],
      restaurant_uuid: JOHNS_SEAFOOD_HOUSE_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for 110 Grill',
        es: 'Based on latest order history, this item is at risk for 110 Grill',
        fr: 'Based on latest order history, this item is at risk for 110 Grill',
        zh: 'Based on latest order history, this item is at risk for 110 Grill',
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '884a8f8f-7849-4753-afd8-213827116058',
    },
  ],
  [KENS_CATERING_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: KENS_CATERING_CHAT_UUID,
      display_name: 'Aladdin Bakery™ 12 Inch Spinach Wraps',
      external_item_id: '',
      pack_unit: 'Case',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/025ef093-4d84-5395-ba1b-eae6e63fc7ee.png',
      ],
      restaurant_uuid: KENS_CATERING_RESTAURANT_UUID,
      subtitle: {
        en: "Based on latest order history, this item is at risk for Ken's Catering Co.",
        es: "Según el historial de pedidos más reciente, este artículo está en riesgo para Ken's Catering Co.",
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Ken's Catering Co.",
        zh: "根據最新訂單歷史，此商品對 Ken's Catering Co. 存在風險",
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: 'ce990a37-a8a0-47b7-8690-23a9c6ea5396',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: KENS_CATERING_CHAT_UUID,
      restaurant_uuid: KENS_CATERING_RESTAURANT_UUID,
      subtitle: {
        en: "Ken's Catering Co. hasn't placed an order in 12 days. The previous largest gap in ordering was 6 days.",
        es: "Ken's Catering Co. no ha realizado un pedido en 12 días. El mayor intervalo sin pedidos anterior fue de 6 días.",
        fr: "Ken's Catering Co. n'a pas passé commande depuis 12 jours. Le plus grand intervalle sans commande précédent était de 6 jours.",
        zh: "Ken's Catering Co. 已經有 12 天沒有下單。前一個最大間隔沒有訂單的時間是 6 天。",
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],

  // --- Meat ---
  [LAKESHORE_DELI_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: LAKESHORE_DELI_CHAT_UUID,
      display_name: 'Choice Veal Chop 10-12 oz',
      external_item_id: '',
      pack_unit: 'Box',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/b8109b25-a7aa-5de3-a9e2-bc2e8a0269df.jpg',
      ],
      restaurant_uuid: LAKESHORE_DELI_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Lakeshore Deli',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Lakeshore Deli',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Lakeshore Deli",
        zh: '根據最新訂單歷史，此商品對 Lakeshore Deli 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '3b0dd61e-18f2-44a8-a741-06c67c119972',
    },
  ],
  [MALLORYS_SEAFOOD_CHAT_UUID]: [],
  [MALLORYS_STEAKHOUSE_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: MALLORYS_STEAKHOUSE_CHAT_UUID,
      restaurant_uuid: MALLORYS_STEAKHOUSE_RESTAURANT_UUID,
      subtitle: {
        en: "Mallory's Steakhouse hasn't placed an order in 12 days. The previous largest gap in ordering was 6 days.",
        es: "Mallory's Steakhouse no ha realizado un pedido en 12 días. El mayor intervalo sin pedidos anterior fue de 6 días.",
        fr: "Mallory's Steakhouse n'a pas passé commande depuis 12 jours. Le plus grand intervalle sans commande précédent était de 6 jours.",
        zh: "Mallory's Steakhouse 已經有 12 天沒有下單。前一個最大間隔沒有訂單的時間是 6 天。",
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],

  // --- C-Store ---
  [MAPLEWOOD_MART_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: MAPLEWOOD_MART_CHAT_UUID,
      restaurant_uuid: MAPLEWOOD_MART_RESTAURANT_UUID,
      subtitle: {
        en: "Maplewood Mart hasn't placed an order in 9 days. The previous largest gap in ordering was 4 days.",
        es: 'Maplewood Mart no ha realizado un pedido en 9 días. El mayor intervalo sin pedidos anterior fue de 4 días.',
        fr: "Maplewood Mart n'a pas passé commande depuis 9 jours. Le plus grand intervalle sans commande précédent était de 4 jours.",
        zh: 'Maplewood Mart 已經有 9 天沒有下單。前一個最大間隔沒有訂單的時間是 4 天。',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.OverduePayment,
      chat_uuid: MAPLEWOOD_MART_CHAT_UUID,
      data: [
        {
          alert_uuid: uuidv4(),
          amount: 670000000,
          due_at: '2026-03-28 06:00:00.000 Z',
          invoice_number: 'MPW10482',
          order_invoice_uuid: uuidv4(),
        },
        {
          alert_uuid: uuidv4(),
          amount: 250000000,
          due_at: '2026-03-21 06:00:00.000 Z',
          invoice_number: 'MPW10371',
          order_invoice_uuid: uuidv4(),
        },
      ],
      restaurant_uuid: MAPLEWOOD_MART_RESTAURANT_UUID,
      subtitle: {
        en: 'Maplewood Mart has 2 overdue invoices totaling $920.00',
        es: 'Maplewood Mart tiene 2 facturas vencidas por un total de $920.00',
        fr: 'Maplewood Mart a 2 factures en retard pour un total de 920,00 $',
        zh: 'Maplewood Mart 有 2 張逾期發票，總計 $920.00',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Overdue Payment',
        es: 'Pago vencido',
        fr: 'Paiement en retard',
        zh: '逾期付款',
      },
    },
  ],
  [MARILUS_MARKET_CHAT_UUID]: [],
  [NOUVEAU_BISTRO_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: NOUVEAU_BISTRO_CHAT_UUID,
      restaurant_uuid: NOUVEAU_BISTRO_RESTAURANT_UUID,
      subtitle: {
        en: "Nouveau Bistro hasn't placed an order in 13 days (9/5). The previous largest gap in ordering was 6 days.",
        es: "Nouveau Bistro hasn't placed an order in 13 days (9/5). The previous largest gap in ordering was 6 days.",
        fr: "Nouveau Bistro n'a pas passé commande depuis 13 jours (9/5). Le plus grand intervalle sans commande précédent était de 6 jours.",
        zh: 'Nouveau Bistro 已經有 13 天沒有下單 (9/5)。前一個最大間隔沒有訂單的時間是 6 天。',
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.OverduePayment,
      chat_uuid: NOUVEAU_BISTRO_CHAT_UUID,
      data: [
        {
          alert_uuid: uuidv4(),
          amount: 1696650000,
          due_at: '2023-11-08 06:00:00.000 Z',
          invoice_number: 'VQOVS3YZS',
          order_invoice_uuid: uuidv4(),
        },
        {
          alert_uuid: uuidv4(),
          amount: 2652190000,
          due_at: '2023-11-06 06:00:00.000 Z',
          invoice_number: 'GGCZPYOHX',
          order_invoice_uuid: uuidv4(),
        },
        {
          alert_uuid: uuidv4(),
          amount: 1536650000,
          due_at: '2023-11-04 06:00:00.000 Z',
          invoice_number: 'GD7OFGEA4',
          order_invoice_uuid: uuidv4(),
        },
        {
          alert_uuid: uuidv4(),
          amount: 2013350000,
          due_at: '2023-10-28 06:00:00.000 Z',
          invoice_number: 'CX2FBJ972',
          order_invoice_uuid: uuidv4(),
        },
      ],
      restaurant_uuid: NOUVEAU_BISTRO_RESTAURANT_UUID,
      subtitle: {
        en: 'Nouveau Bistro has 4 overdue invoices.',
        es: 'Nouveau Bistro tiene 4 facturas vencidas.',
        fr: 'Nouveau Bistro a 4 factures en retard.',
        zh: 'Nouveau Bistro 有 4 張逾期未付的發票。',
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Overdue Payment',
        es: 'Factura vencida',
        fr: 'Facture en retard',
        zh: '逾期未付發票',
      },
    },
  ],
  [RAYS_CSTORE_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: RAYS_CSTORE_CHAT_UUID,
      display_name: 'Creamy Peanut Butter',
      external_item_id: '',
      pack_unit: 'Case',
      photo_url_list: [
        'https://pepper-image-sync-production.s3.amazonaws.com/479f4ae8-a3ba-5c75-8983-eeb01f72d8d7.jpg',
      ],
      restaurant_uuid: RAYS_CSTORE_RESTAURANT_UUID,
      subtitle: {
        en: "Based on latest order history, this item is at risk for Ray's C-Store",
        es: "Según el historial de pedidos más reciente, este artículo está en riesgo para Ray's C-Store",
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Ray's C-Store",
        zh: "根據最新訂單歷史，此商品對 Ray's C-Store 存在風險",
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '43ce30ee-1629-4fd0-baf2-81029ddb60ab',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: RAYS_CSTORE_CHAT_UUID,
      restaurant_uuid: RAYS_CSTORE_RESTAURANT_UUID,
      subtitle: {
        en: "Ray's C-Store hasn't placed an order in 10 days. The previous largest gap in ordering was 5 days.",
        es: "Ray's C-Store no ha realizado un pedido en 10 días. El mayor intervalo sin pedidos anterior fue de 5 días.",
        fr: "Ray's C-Store n'a pas passé commande depuis 10 jours. Le plus grand intervalle sans commande précédent était de 5 jours.",
        zh: "Ray's C-Store 已經有 10 天沒有下單。前一個最大間隔沒有訂單的時間是 5 天。",
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.OverduePayment,
      chat_uuid: RAYS_CSTORE_CHAT_UUID,
      data: [
        {
          alert_uuid: uuidv4(),
          amount: 485000000,
          due_at: '2026-03-30 06:00:00.000 Z',
          invoice_number: 'RAY20815',
          order_invoice_uuid: uuidv4(),
        },
        {
          alert_uuid: uuidv4(),
          amount: 312000000,
          due_at: '2026-03-24 06:00:00.000 Z',
          invoice_number: 'RAY20743',
          order_invoice_uuid: uuidv4(),
        },
      ],
      restaurant_uuid: RAYS_CSTORE_RESTAURANT_UUID,
      subtitle: {
        en: "Ray's C-Store has 2 overdue invoices totaling $797.00",
        es: "Ray's C-Store tiene 2 facturas vencidas por un total de $797.00",
        fr: "Ray's C-Store a 2 factures en retard pour un total de 797,00 $",
        zh: "Ray's C-Store 有 2 張逾期發票，總計 $797.00",
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Overdue Payment',
        es: 'Pago vencido',
        fr: 'Paiement en retard',
        zh: '逾期付款',
      },
    },
  ],
  [RAZAS_RESTAURANT_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.OverduePayment,
      chat_uuid: RAZAS_RESTAURANT_CHAT_UUID,
      data: [
        {
          alert_uuid: uuidv4(),
          amount: 1696650000,
          due_at: '2023-11-08 06:00:00.000 Z',
          invoice_number: 'VQOVS3YZS',
          order_invoice_uuid: uuidv4(),
        },
        {
          alert_uuid: uuidv4(),
          amount: 2652190000,
          due_at: '2023-11-06 06:00:00.000 Z',
          invoice_number: 'GGCZPYOHX',
          order_invoice_uuid: uuidv4(),
        },
        {
          alert_uuid: uuidv4(),
          amount: 1536650000,
          due_at: '2023-11-04 06:00:00.000 Z',
          invoice_number: 'GD7OFGEA4',
          order_invoice_uuid: uuidv4(),
        },
        {
          alert_uuid: uuidv4(),
          amount: 2013350000,
          due_at: '2023-10-28 06:00:00.000 Z',
          invoice_number: 'CX2FBJ972',
          order_invoice_uuid: uuidv4(),
        },
      ],
      restaurant_uuid: RAZAS_RESTAURANT_RESTAURANT_UUID,
      subtitle: {
        en: "Raza's Restaurant has 4 overdue invoices.",
        es: "Raza's Restaurant tiene 4 facturas vencidas.",
        fr: "Raza's Restaurant a 4 factures en retard.",
        zh: "Raza's Restaurant 有 4 張逾期未付的發票。",
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Overdue Payment',
        es: 'Factura vencida',
        fr: 'Facture en retard',
        zh: '逾期未付發票',
      },
    },
  ],
  [RIDGELINE_CSTORE_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: RIDGELINE_CSTORE_CHAT_UUID,
      display_name: 'Dilly Bites',
      external_item_id: '',
      pack_unit: 'Case',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/0aa3cf2c-d776-5c60-9c01-93c6e2dacd9d.jpg',
      ],
      restaurant_uuid: RIDGELINE_CSTORE_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Ridgeline C-Store',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Ridgeline C-Store',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Ridgeline C-Store",
        zh: '根據最新訂單歷史，此商品對 Ridgeline C-Store 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: 'f3ad3e9f-2f54-49cd-a547-45e3e278e0d5',
    },
  ],
  [ROESES_RIB_ROOM_CHAT_UUID]: [],
  [RYANS_RIPPIN_RESTAURANT_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: RYANS_RIPPIN_RESTAURANT_CHAT_UUID,
      display_name: 'Beef Broth - Oh: 9',
      external_item_id: '0593285',
      pack_unit: 'EACH',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/f4d8ba32-df5a-4bad-bf94-cf0a1c89e109/items/2e059f4b-1bf7-493b-97c6-b0baf52975bf.png',
      ],
      restaurant_uuid: RYANS_RIPPIN_RESTAURANT_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Ryans Rippin Restaurant',
        es: 'Based on latest order history, this item is at risk for Ryans Rippin Restaurant',
        fr: 'Based on latest order history, this item is at risk for Ryans Rippin Restaurant',
        zh: 'Based on latest order history, this item is at risk for Ryans Rippin Restaurant',
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '9162c343-c977-444f-8b00-716b4be45669',
    },
  ],
  [SIAM_DISH_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: SIAM_DISH_CHAT_UUID,
      display_name: 'Chives | 韭菜',
      external_item_id: '',
      pack_unit: 'Case',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/e46a29a9-acb4-504a-959f-2155102e003b.jpg',
      ],
      restaurant_uuid: SIAM_DISH_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Siam Dish',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Siam Dish',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Siam Dish",
        zh: '根據最新訂單歷史，此商品對 Siam Dish 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '12be32c6-b251-408b-988d-8c018bce58cc',
    },
  ],
  [SPECIALTY_GOODS_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: SPECIALTY_GOODS_CHAT_UUID,
      display_name:
        'Compact ® Coreless 1-Ply Recycled Toilet Paper by GP PRO (Georgia-Pacific), 3000 Sheets Per Roll, 18 Rolls Per Case',
      external_item_id: '925273',
      pack_unit: 'CASE',
      photo_url_list: [
        'https://pepper-salt-production.s3.us-east-1.amazonaws.com/ds_essendant/images/0193b75c-edf5-7d20-8e7b-bd31f7c7fcee/4e791f68-a7fa-4326-b8bc-7a48982dde9a.jpg',
      ],
      restaurant_uuid: SPECIALTY_GOODS_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for 110 Grill',
        es: 'Based on latest order history, this item is at risk for 110 Grill',
        fr: 'Based on latest order history, this item is at risk for 110 Grill',
        zh: 'Based on latest order history, this item is at risk for 110 Grill',
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '6053a5e1-c244-4f0c-97c6-0de363868281',
    },
  ],
  [ST_MORITZ_HOTEL_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: ST_MORITZ_HOTEL_CHAT_UUID,
      display_name:
        'Diversey™ Crew Concentrated Restroom Floor & Surface Non-Acid Disinfectant Cleaner',
      external_item_id: '',
      pack_unit: 'Each',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/f4a10632-6579-57c9-b3ea-7a378787c97c.jpg',
      ],
      restaurant_uuid: ST_MORITZ_HOTEL_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for St. Moritz Hotel',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para St. Moritz Hotel',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour St. Moritz Hotel",
        zh: '根據最新訂單歷史，此商品對 St. Moritz Hotel 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '470c1d97-b5b4-472e-a1af-4ef2e957d8f2',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: ST_MORITZ_HOTEL_CHAT_UUID,
      restaurant_uuid: ST_MORITZ_HOTEL_RESTAURANT_UUID,
      subtitle: {
        en: "St. Moritz Hotel hasn't placed an order in 10 days. The previous largest gap in ordering was 5 days.",
        es: 'St. Moritz Hotel no ha realizado un pedido en 10 días. El mayor intervalo sin pedidos anterior fue de 5 días.',
        fr: "St. Moritz Hotel n'a pas passé commande depuis 10 jours. Le plus grand intervalle sans commande précédent était de 5 jours.",
        zh: 'St. Moritz Hotel 已經有 10 天沒有下單。前一個最大間隔沒有訂單的時間是 5 天。',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],
  [SUMMIT_STEAKHOUSE_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: SUMMIT_STEAKHOUSE_CHAT_UUID,
      display_name: '100% Grass Fed Natural',
      external_item_id: '',
      pack_unit: 'Piece',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/3bde8929-599d-595e-8e38-f4ce0cb9247a.jpg',
      ],
      restaurant_uuid: SUMMIT_STEAKHOUSE_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Summit Steakhouse',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Summit Steakhouse',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Summit Steakhouse",
        zh: '根據最新訂單歷史，此商品對 Summit Steakhouse 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: 'cac90f02-7e6f-4199-9a1b-e7745569f4e1',
    },
  ],
  [THE_CARRIAGE_HOUSE_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: THE_CARRIAGE_HOUSE_CHAT_UUID,
      display_name: 'Bagel Plain Sliced 6ct/12bags',
      external_item_id: '',
      pack_unit: 'Case',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/499474d2-1d12-5730-9288-2852ab363e2b.jpg',
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/5bd840a5-737b-50e1-a982-65b427980a31.jpg',
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/ba277501-2396-540a-894a-7698adbad8af.jpg',
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/9ea42485-3874-5e05-9490-952584c793df.jpg',
      ],
      restaurant_uuid: THE_CARRIAGE_HOUSE_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for The Carriage House',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para The Carriage House',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour The Carriage House",
        zh: '根據最新訂單歷史，此商品對 The Carriage House 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '11fddf9e-888f-401c-b1d2-6f1ec3dc97db',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: THE_CARRIAGE_HOUSE_CHAT_UUID,
      restaurant_uuid: THE_CARRIAGE_HOUSE_RESTAURANT_UUID,
      subtitle: {
        en: "The Carriage House hasn't placed an order in 8 days. The previous largest gap in ordering was 4 days.",
        es: 'The Carriage House no ha realizado un pedido en 8 días. El mayor intervalo sin pedidos anterior fue de 4 días.',
        fr: "The Carriage House n'a pas passé commande depuis 8 jours. Le plus grand intervalle sans commande précédent était de 4 jours.",
        zh: 'The Carriage House 已經有 8 天沒有下單。前一個最大間隔沒有訂單的時間是 4 天。',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],
  [THE_CARVING_BLOCK_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: THE_CARVING_BLOCK_CHAT_UUID,
      display_name: 'Beef Diced Handcut 2" x 2"',
      external_item_id: '',
      pack_unit: 'Pound',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/cafa4111-4bb4-5e89-a9cb-55f8c29ccace.jpg',
      ],
      restaurant_uuid: THE_CARVING_BLOCK_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for The Carving Block',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para The Carving Block',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour The Carving Block",
        zh: '根據最新訂單歷史，此商品對 The Carving Block 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '6802508f-f646-4040-bfb5-46be9e4307e5',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: THE_CARVING_BLOCK_CHAT_UUID,
      restaurant_uuid: THE_CARVING_BLOCK_RESTAURANT_UUID,
      subtitle: {
        en: "The Carving Block hasn't placed an order in 9 days. The previous largest gap in ordering was 5 days.",
        es: 'The Carving Block no ha realizado un pedido en 9 días. El mayor intervalo sin pedidos anterior fue de 5 días.',
        fr: "The Carving Block n'a pas passé commande depuis 9 jours. Le plus grand intervalle sans commande précédent était de 5 jours.",
        zh: 'The Carving Block 已經有 9 天沒有下單。前一個最大間隔沒有訂單的時間是 5 天。',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],
  [THE_DAILY_PLATE_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: THE_DAILY_PLATE_CHAT_UUID,
      display_name: 'Bbq Sauce | Sweet Baby Rays 1G',
      external_item_id: '',
      pack_unit: 'Case',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/6deadacd-43a3-5ee5-9a09-cdd98faebcbd.png',
      ],
      restaurant_uuid: THE_DAILY_PLATE_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for The Daily Plate',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para The Daily Plate',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour The Daily Plate",
        zh: '根據最新訂單歷史，此商品對 The Daily Plate 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '30a7cfa0-fe5c-4fae-82f7-ad3d1b77c486',
    },
  ],
  [THE_DUCK_INN_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.OverduePayment,
      chat_uuid: THE_DUCK_INN_CHAT_UUID,
      data: [
        {
          alert_uuid: uuidv4(),
          amount: 1235730000,
          due_at: '2023-07-28 06:00:00.000 Z',
          invoice_number: 'NNJT8R',
          order_invoice_uuid: '0d3743cb-a620-40c6-9648-960d71bc3e21',
        },
      ],
      restaurant_uuid: THE_DUCK_INN_RESTAURANT_UUID,
      subtitle: {
        en: 'Missed payment as of 7/28',
        es: 'Pago atrasado desde el 28/7',
        fr: 'Paiement en retard depuis le 28/7',
        zh: '7/28 的逾期付款',
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Overdue Payment',
        es: 'Factura vencida',
        fr: 'Facture en retard',
        zh: '逾期未付發票',
      },
    },
  ],
  [THE_PROVISIONS_COUNTER_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: THE_PROVISIONS_COUNTER_CHAT_UUID,
      display_name: 'Bold 3 Pepper Colby Jack® Cheese',
      external_item_id: '',
      pack_unit: 'Each',
      photo_url_list: [],
      restaurant_uuid: THE_PROVISIONS_COUNTER_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for The Provisions Counter',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para The Provisions Counter',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour The Provisions Counter",
        zh: '根據最新訂單歷史，此商品對 The Provisions Counter 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '06d40b01-69f3-4fb7-b968-bbb516336d38',
    },
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: THE_PROVISIONS_COUNTER_CHAT_UUID,
      restaurant_uuid: THE_PROVISIONS_COUNTER_RESTAURANT_UUID,
      subtitle: {
        en: "The Provisions Counter hasn't placed an order in 9 days. The previous largest gap in ordering was 4 days.",
        es: 'The Provisions Counter no ha realizado un pedido en 9 días. El mayor intervalo sin pedidos anterior fue de 4 días.',
        fr: "The Provisions Counter n'a pas passé commande depuis 9 jours. Le plus grand intervalle sans commande précédent était de 4 jours.",
        zh: 'The Provisions Counter 已經有 9 天沒有下單。前一個最大間隔沒有訂單的時間是 4 天。',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],
  [THE_REAL_SCOOP_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: THE_REAL_SCOOP_CHAT_UUID,
      display_name: 'Chocolate Fudge Bars 25 Fl Oz Pack Of 6',
      external_item_id: '',
      pack_unit: 'Each',
      photo_url_list: [],
      restaurant_uuid: THE_REAL_SCOOP_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for The Real Scoop',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para The Real Scoop',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour The Real Scoop",
        zh: '根據最新訂單歷史，此商品對 The Real Scoop 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '1b47ea11-b352-4a54-989e-b5138b21ed06',
    },
  ],
  [THE_SURF_CLUB_RESTAURANT_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.OverduePayment,
      chat_uuid: THE_SURF_CLUB_RESTAURANT_CHAT_UUID,
      data: [
        {
          alert_uuid: uuidv4(),
          amount: 1235730000,
          due_at: '2023-07-03 06:00:00.000 Z',
          invoice_number: '1UEKR0VQY',
          order_invoice_uuid: '103e2bc7-bc12-499b-84e3-cb4a56d2e414',
        },
      ],
      restaurant_uuid: THE_SURF_CLUB_RESTAURANT_RESTAURANT_UUID,
      subtitle: {
        en: 'Missed payment as of 7/3',
        es: 'Pago atrasado desde el 3/7',
        fr: 'Paiement en retard depuis le 3/7',
        zh: '7/3 的逾期付款',
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Overdue Payment',
        es: 'Factura vencida',
        fr: 'Facture en retard',
        zh: '逾期未付發票',
      },
    },
  ],
  [TINA_TUNA_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.ChurnRisk,
      alert_uuid: uuidv4(),
      chat_uuid: TINA_TUNA_CHAT_UUID,
      restaurant_uuid: TINA_TUNA_RESTAURANT_UUID,
      subtitle: {
        en: "Tina's Tunas hasn't placed an order in 15 days (7/13). The previous largest gap in ordering was 14",
        es: "Tina's Tunas no ha realizado un pedido en 15 días (7/13). El mayor intervalo sin pedidos anterior fue de 14",
        fr: "Tina's Tunas n'a pas passé commande depuis 15 jours (7/13). Le plus grand intervalle sans commande précédent était de 14",
        zh: "Tina's Tunas 已經有 15 天沒有下單 (7/13)。前一個最大間隔沒有訂單的時間是 14",
      },
      supplier_uuid: SFF_SUPPLIER_UUID,
      title: {
        en: 'Churn Risk',
        es: 'Riesgo de churn',
        fr: 'Risque de churn',
        zh: '流失風險',
      },
    },
  ],
  [VALLEY_EXPRESS_CHAT_UUID]: [
    {
      alert_status: AnalyticsAlertStatusType.Active,
      alert_type: AnalyticsAlertType.LostItem,
      alert_uuid: uuidv4(),
      chat_uuid: VALLEY_EXPRESS_CHAT_UUID,
      display_name: 'Turkey and Cheddar Cracker Stackers',
      external_item_id: '',
      pack_unit: 'Case',
      photo_url_list: [
        'https://s3.amazonaws.com/media.usepepper.com/suppliers/abf2eaaa-e22c-4553-a34e-d2300b073b26/items/04b0a7d1-ed88-5ca4-9183-42602af5d994.jpg',
      ],
      restaurant_uuid: VALLEY_EXPRESS_RESTAURANT_UUID,
      subtitle: {
        en: 'Based on latest order history, this item is at risk for Valley Express',
        es: 'Según el historial de pedidos más reciente, este artículo está en riesgo para Valley Express',
        fr: "Selon l'historique des commandes récentes, cet article est à risque pour Valley Express",
        zh: '根據最新訂單歷史，此商品對 Valley Express 存在風險',
      },
      supplier_uuid: BRONCO_SUPPLIER_UUID,
      title: {
        en: 'Lost Item',
        es: 'Artículo perdido',
        fr: 'Article perdu',
        zh: '遺失物品',
      },
      variant_pack_uuid: '15c0b3bc-8aa1-45f2-a2d4-da8ddb7d5786',
    },
  ],
  [WESS_BISTRO_CHAT_UUID]: [],
};

const ONE_MICROS = 1000000;
const MINIMUM_ORDER_AMOUNT_REDUCTION_FACTOR = 1500;

interface MockedTotalOrdersDataItem {
  period: string;
  totalOrdersCount: number;
}

interface MockedTotalSalesDataItem {
  date: string;
  orderAmountInMicros: number;
}

interface MockedTotalSalesData {
  avgOrderSize: number;
  grossProfitInMicros: number | null | undefined;
  grossProfitPercentOverPeriod: number | null | undefined;
  totalOrders: number;
  totalOrdersData: MockedTotalOrdersDataItem[];
  totalSalesData: MockedTotalSalesDataItem[];
  totalSalesInMicros: number;
  totalSalesPercentOverPeriod: number | null | undefined;
}

interface MockData {
  mockAnalyticsData: {
    [chatUUID: string]: {
      [period: number]: {
        mockData: MockedTotalSalesData;
      };
    };
  };
}

export const generateTotalSalesData = async (
  chatUUID: string,
  endDate: Date,
  startDate: Date,
): Promise<MockedTotalSalesData> => {
  const storedMockData = await AsyncStorage.getItem('mockAnalyticsData');
  const mockDataStorageTimestamp = await AsyncStorage.getItem(
    'generatedSalesDataTimestamp',
  );
  const graphPeriods = [7, 14, 30, 60, 120];
  const showUpwardsSalesTrend =
    CHIPOTLE_MEXICAN_GRILL_CHAT_UUID === chatUUID ||
    BOBS_BURGER_SHACK_CHAT_UUID === chatUUID;
  let minimumOrderAmount = showUpwardsSalesTrend ? 9000 : 1;

  let daysDifference =
    (endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24);

  daysDifference =
    daysDifference < 10
      ? 7
      : daysDifference < 60
        ? 30
        : daysDifference < 120
          ? 60
          : daysDifference;

  if (
    storedMockData &&
    mockDataStorageTimestamp &&
    !isDataOlderThanOneDay(Number(mockDataStorageTimestamp)) &&
    JSON.parse(storedMockData).mockAnalyticsData[chatUUID]
  ) {
    return JSON.parse(storedMockData).mockAnalyticsData[chatUUID][
      daysDifference
    ].mockData;
  }

  const end = new Date(endDate);
  end.setDate(endDate.getDate());
  // Always generate data for the last 120 days
  const fixed_start = new Date(endDate);
  fixed_start.setDate(endDate.getDate() - 120);

  let dayCounter = 0;
  let totalOrders = 0;
  let totalOrdersPerWeek = 0;
  let totalSalesInMicros = 0;
  let periodStart = new Date(end);
  let newMockData: MockData = storedMockData
    ? JSON.parse(storedMockData)
    : { mockAnalyticsData: {} };

  const salesData: MockedTotalSalesDataItem[] = [];
  const ordersData: MockedTotalOrdersDataItem[] = [];

  let hasChurnRisk = mockAlertsData[chatUUID]
    ? mockAlertsData[chatUUID].some(
        (alert) => alert.alert_type === AnalyticsAlertType.ChurnRisk,
      )
    : false;
  let shouldUseChurnRiskValue = false;
  let numberOfWeeksForChurnRisk = 4;

  const grossProfitPercentage = (Math.random() * (10 - 0.5) + 0.5).toFixed(2); // random between 0.5 and 10

  while (end > fixed_start) {
    dayCounter += 1;
    if (hasChurnRisk && numberOfWeeksForChurnRisk > 0) {
      shouldUseChurnRiskValue = true;
    }

    const numOrdersForDay = generateRandomNumberOfOrders(
      showUpwardsSalesTrend,
      shouldUseChurnRiskValue,
    );
    let totalSaleAmountForTheDay = 0;

    for (let i = 0; i < numOrdersForDay; i++) {
      const orderAmountInMicros = generateRandomTotalAmountInMicros(
        minimumOrderAmount,
        shouldUseChurnRiskValue,
      );
      totalSaleAmountForTheDay += orderAmountInMicros;
    }
    totalOrders += numOrdersForDay;
    totalOrdersPerWeek += numOrdersForDay;
    totalSalesInMicros += totalSaleAmountForTheDay;

    salesData.push({
      date: formatISODate(end),
      orderAmountInMicros: totalSaleAmountForTheDay,
    });
    end.setDate(end.getDate() - 1); // Move to the previous day

    if (dayCounter % 7 === 0) {
      numberOfWeeksForChurnRisk = numberOfWeeksForChurnRisk - 1;
      if (numberOfWeeksForChurnRisk === 0) {
        shouldUseChurnRiskValue = false;
      }
      const period = `${formatDate(end)} - ${formatDate(periodStart)}`;
      periodStart = new Date(end);
      ordersData.push({
        period,
        totalOrdersCount: totalOrdersPerWeek,
      });
      totalOrdersPerWeek = 0;
    }

    if (graphPeriods.includes(dayCounter)) {
      const avgOrderSize = shouldUseChurnRiskValue
        ? 0
        : Math.floor(Math.random() * (30 - 5 + 1)) + 5; // random between 5 and 30

      const grossProfitInMicros =
        (totalSalesInMicros * Number(grossProfitPercentage)) / 100;

      const grossProfitPercentOverPeriod = 0; // placeholder

      const totalSalesPercentOverPeriod = 0; // placeholder

      const salesDataSnapshot = [...salesData];
      const ordersDataSnapshot = [...ordersData];

      const generatedData: MockedTotalSalesData = {
        avgOrderSize: avgOrderSize,
        grossProfitInMicros: grossProfitInMicros,
        grossProfitPercentOverPeriod: Number(grossProfitPercentOverPeriod),
        totalOrders: totalOrders,
        totalOrdersData: ordersDataSnapshot.reverse(),
        totalSalesData: salesDataSnapshot.reverse(),
        totalSalesInMicros: totalSalesInMicros,
        totalSalesPercentOverPeriod: Number(totalSalesPercentOverPeriod),
      };

      newMockData.mockAnalyticsData = {
        ...(newMockData.mockAnalyticsData || {}),
        [chatUUID]: {
          ...(newMockData.mockAnalyticsData?.[chatUUID] || {}),
          [dayCounter]: {
            mockData: generatedData,
          },
        },
      };

      if (showUpwardsSalesTrend) {
        minimumOrderAmount -= MINIMUM_ORDER_AMOUNT_REDUCTION_FACTOR;
      }
    }
  }

  graphPeriods.forEach((currentPeriod, index, array) => {
    if (index < array.length - 1) {
      const nextPeriod = array[index + 1];
      const currentData =
        newMockData.mockAnalyticsData[chatUUID][currentPeriod].mockData;
      const nextData =
        newMockData.mockAnalyticsData[chatUUID][nextPeriod].mockData;

      currentData.grossProfitPercentOverPeriod = calculatePercentageChange(
        currentData.grossProfitInMicros,
        nextData.grossProfitInMicros,
      );

      currentData.totalSalesPercentOverPeriod = calculatePercentageChange(
        currentData.totalSalesInMicros,
        nextData.totalSalesInMicros,
      );
    }
  });

  await AsyncStorage.setItem('mockAnalyticsData', JSON.stringify(newMockData));
  await AsyncStorage.setItem(
    'generatedSalesDataTimestamp',
    Date.now().toString(),
  );

  return newMockData.mockAnalyticsData[chatUUID][daysDifference].mockData;
};

const generateRandomNumberOfOrders = (
  showUpwardsSalesTrend: boolean,
  shouldUseChurnRiskValue: boolean,
): number => {
  if (shouldUseChurnRiskValue) {
    return 0;
  } else if (showUpwardsSalesTrend) {
    return 1;
  } else {
    return Math.floor(Math.random() * 10) + 1; // Max number of orders in a day will be 10
  }
};

const generateRandomTotalAmountInMicros = (
  minimumOrderAmount: number,
  shouldUseChurnRiskValue: boolean,
): number => {
  let randomAmount: number;
  if (shouldUseChurnRiskValue) {
    randomAmount = Math.floor(Math.random() * 100) + 1;
  } else if (minimumOrderAmount > 1) {
    randomAmount = Math.floor(Math.random() * 1001) + minimumOrderAmount;
  } else {
    randomAmount = Math.floor(Math.random() * 10000) + minimumOrderAmount;
  }
  return randomAmount * ONE_MICROS + 1;
};

const isDataOlderThanOneDay = (timestamp: number) => {
  const currentDate = Date.now();
  const oneDayInMillis = 24 * 60 * 60 * 1000;

  return currentDate - timestamp > oneDayInMillis;
};

const calculatePercentageChange = (
  newValue: number | null | undefined,
  oldValue: number | null | undefined,
) => {
  // L14 = $1100 L7 = $600 => previousPeriodValue = $1100 - $600 = $500 (increment by 20%)
  if (newValue && oldValue) {
    const valueForPreviousPeriod = oldValue - newValue;
    return Number(
      (
        ((newValue - valueForPreviousPeriod) / Math.abs(oldValue)) *
        100
      ).toFixed(2),
    );
  } else {
    return null;
  }
};

function formatDate(date: Date): string {
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${month}/${day}`;
}

function formatISODate(date: Date): string {
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  // Combine into YYYY-MM-DD format
  return `${year}-${month}-${day}`;
}

/**
 * Returns mock alerts for a Bronco demo restaurant, or undefined if not a demo account.
 */
export const getDemoAlertsForBroncoRestaurant = (
  restaurantUUID: string,
): AnalyticsAlertResponse[] | undefined => {
  const chatUUID = BRONCO_DEMO_RESTAURANT_TO_CHAT[restaurantUUID];
  if (!chatUUID) {
    return undefined;
  }

  return mockAlertsData[chatUUID] ?? [];
};
